import { PropsWithChildren } from 'react';

import { Input } from '@atom/form/input/input';
import { Form } from '@form/common.style';
import { Label } from '@form/connector-auth/connector-auth.form-style';
import { FormError } from '@form/form-error';
import { BaseFormInterface } from '@interface/form/base-form.interface';

export const OtpForm = ({ form, error }: PropsWithChildren<BaseFormInterface>) => (
  <Form autoComplete='off' form={form} layout='vertical' name='otp'>
    <Label label='Validation code' name='otp'>
      <Input placeholder='000 000' />
    </Label>
    <FormError customErrorField='key' error={error} errorField='otp' />
  </Form>
);
